<template>
    <div class="post-hero">
        <div class="container mb-5">
            <div class="row">
                <div class="col-sm-4">
                    <div class="featured-item-03 clearfix">
                        <div class="icon">
                            <font-awesome-icon icon="thumbs-up"/>
                        </div>
                        <div class="content">
                            <h5>Calidad Asegurada</h5>
                            <p>So by colonel hearted ferrars. Draw from upon here gone add one. He in sportsman
                                household otherwise.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="featured-item-03 clearfix">
                        <div class="icon">
                            <font-awesome-icon icon="wallet"/>
                        </div>
                        <div class="content">
                            <h5>Reserva al mejor precio</h5>
                            <p>Whatever throwing we on resolved entrance together graceful. Mrs assured add private
                                married removed.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="featured-item-03 clearfix">
                        <div class="icon">
                            <font-awesome-icon icon="heart"/>
                        </div>
                        <div class="content">
                            <h5>Nos importa tu felicidad</h5>
                            <p>Dependent certainty off discovery him his tolerably offending. Ham for attention
                                remainder sometimes.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'claims'
    }
</script>
<style scoped>
    .icon {
        color: #8ea9ba !important;
        background: transparent !important;
    }

    .featured-item-03 h5 {
        letter-spacing: 0px !important;
    }
</style>